import { Card, IconButton, InputAdornment, Stack } from "@mui/material";
import FormProvider from "../../../../../components/hook-form/form-provider";
import useUpdatePasswordUser from "./useUpdatePassword"
import { RHFTextField } from "../../../../../components/hook-form";
import Iconify from "../../../../../components/iconify";
import { LoadingButton } from "@mui/lab";

const UpdatePasswordUserView = () => {

    const { onSubmit, isSubmitting, methods, password } = useUpdatePasswordUser();

    return (
        <FormProvider methods={methods} onSubmit={onSubmit}>
            <Stack component={Card} spacing={3} sx={{ p: 3 }}>
                <RHFTextField
                    label="Senha"
                    name="password"
                    type={password.value ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={password.onToggle} edge="end">
                                    <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                <RHFTextField
                    label="Confirme a Senha"
                    name="confirmPassword"
                    type={password.value ? 'text' : 'password'}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton onClick={password.onToggle} edge="end">
                                    <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
                                </IconButton>
                            </InputAdornment>
                        )
                    }}
                />
                <LoadingButton type="submit" variant="contained" loading={isSubmitting} sx={{ ml: 'auto' }}>
                    Alterar Senha
                </LoadingButton>
            </Stack>
        </FormProvider>
    );

}

export default UpdatePasswordUserView;